import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
import { NowPlayingSidebar } from './NowPlayingSidebar';
import { ThemeToggle } from '@/components/ui/ThemeSelector';
import { PlayerBar } from '@/components/player/PlayerBar';
import { MiniPlayer } from '@/components/player/MiniPlayer';
import { FullPlayer } from '@/components/player/FullPlayer';
import { ContentViewTabs } from '@/components/player/ContentViewTabs';
import { LyricsView } from '@/components/player/LyricsView';
import { usePlayer } from '@/context/PlayerContext';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isPlayerVisible, contentView, currentTrack } = usePlayer();

  // Show lyrics overlay when in lyrics mode and track is playing
  const showLyricsOverlay = contentView === 'lyrics' && currentTrack;

  return (
    <div className="min-h-screen bg-bg-base flex">
      {/* Desktop Sidebar (left) */}
      <Sidebar />

      {/* Main content area (center) */}
      <div className="flex-1 flex flex-col min-h-screen min-w-0">
        {/* Mobile/Tablet Header */}
        <Header />

        {/* Desktop header bar */}
        <div className="hidden lg:flex items-center justify-between px-6 py-3 border-b border-subtle">
          {/* Content view tabs (only when track is playing) */}
          <ContentViewTabs />

          {/* Spacer when no tabs */}
          {!currentTrack && <div />}

          <ThemeToggle />
        </div>

        {/* Page content - extra padding when player is visible */}
        <main className={`flex-1 px-4 py-6 lg:px-8 pb-20 ${isPlayerVisible ? 'lg:pb-24' : 'lg:pb-6'}`}>
          {showLyricsOverlay ? (
            <LyricsView />
          ) : (
            <div className="max-w-7xl mx-auto">
              {children}
            </div>
          )}
        </main>
      </div>

      {/* Now Playing Sidebar (right, desktop only, only when track is playing) */}
      <NowPlayingSidebar className="hidden xl:flex" />

      {/* Mobile Bottom Navigation */}
      <MobileNav />

      {/* Global Player Components */}
      <PlayerBar />
      <MiniPlayer />
      <FullPlayer />
    </div>
  );
}

export { Sidebar } from './Sidebar';
export { Header } from './Header';
export { MobileNav } from './MobileNav';
